// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__aBZEG","requiredAsterisk":"Info_requiredAsterisk__2YG1h"};